export const generateNumberString = ({ number, unit }: { number?: number; unit?: string }) => {
  if (number === undefined) return undefined;
  if (unit === undefined) return number;
  return `${number}${unit}`;
};
